module.exports = __webpack_public_path__ + "static/media/proof-of-address-selected.63bf9f37.svg";